import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { StyledProps } from "@mui/styles/styled";
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import {
  IconButton,
} from "@mui/material";

import { List as MenuIcon, X as CloseIcon } from "@phosphor-icons/react";

const useStyles = makeStyles((theme: Theme) => ({
  floatingButton: {
    position: "fixed",
    top: 20,
    left: 16,
    zIndex: theme.zIndex.appBar,
    width: 36,
    height: 36,
    backgroundColor: "rgba(28, 28, 34, 0.85)",
    backdropFilter: "blur(8px)",
    color: "#ededf0",
    borderRadius: "8px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "rgba(37, 37, 48, 0.95)",
      color: "#ffffff",
    },
  },
}));

interface Props extends RouteComponentProps, StyledProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const Topbar = ({ isSidebarOpen, onToggleSidebar }: Props) => {
  const classes = useStyles();

  return (
    <IconButton className={classes.floatingButton} onClick={onToggleSidebar} size="small">
      {isSidebarOpen ? <CloseIcon size={20} weight="bold" /> : <MenuIcon size={20} weight="bold" />}
    </IconButton>
  );
};

export default withRouter(Topbar);
